import React from 'react';
import styled from 'styled-components';
import responsive from '../utils/responsive';

const H1 = styled.h1`
  font-size: 2.5rem;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
  color: ${props => props.theme.textColor.toHex()};
`;

const H2 = styled.h2`
  font-size: 2rem;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
  color: ${props => props.theme.textColor.toHex()};
  ${responsive.xs.andSmaller`
    font-size: ${props => props.theme.textSize.l};
  `}
`;

const H3 = styled.h3`
  font-size: 1.75rem;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
  color: ${props => props.theme.textColor.toHex()};
`;

const H4 = styled.h4`
  font-size: 1.5rem;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
  color: ${props => props.theme.textColor.toHex()};

  ${responsive.xs.andSmaller`
    font-size: ${props => props.theme.textSize.m};
  `}
`;

const H5 = styled.h5`
  font-size: 1.25rem;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
  color: ${props => props.theme.textColor.toHex()};

  ${responsive.xs.andSmaller`
    font-size: ${props => props.theme.textSize.s};
  `}
`;

const H6 = styled.h6`
  font-size: 1rem;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
  color: ${props => props.theme.textColor.toHex()};
`;

const Text = styled.span`
  font-size: ${props =>
    props.theme.textSize[props.size || 'm'] || props.theme.textSize.m};
  white-space: nowrap;

  ${responsive.md.andSmaller`
    white-space: initial;
  `};
  color: ${props => props.theme.textColor.toHex()};
`;

const Truncate = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TruncatedText = ({ children, style }) => (
  <Truncate style={style}>
    <Text>{children}</Text>
  </Truncate>
);

const Italic = styled.span`
  text-align: center;
  font-style: italic;
  opacity: 0.8;
`;

const Paragraph = styled.p`
  font-size: ${props =>
    props.theme.textSize[props.size || 'm'] || props.theme.textSize.m};
  line-height: ${props =>
    props.theme.lineHeight[props.size || 'm'] || props.theme.lineHeight.m};
  margin: ${props =>
      props.theme.lineHeight[props.size || 'm'] || props.theme.lineHeight.m}
    auto;
  color: ${props => props.theme.textColor.toHex()};

  ${responsive.xs.andSmaller`
    font-size: ${props => props.theme.textSize.s};
    line-height: ${props => props.theme.lineHeight.s};
  `}
`;

export { H1, H2, H3, H4, H5, H6, Text, TruncatedText, Paragraph, Italic };
